if (document.getElementById('vue-projects')) {
	let offer = new URLSearchParams(document.location.search.substring(1)).get(
		'offer'
	)

	new Vue({
		mixins: [baseMixin, eventHubMixin, apiMixin],
		el: '#vue-projects',
		data: {
			page: 1,
			perPage: 4,
			projects: [],
			sectors: [],
			loading: true,
			total: null,
			activeSector: undefined
		},
		mounted() {
			this.getSectors()
			this.getProjects()
		},
		computed: {
			hasMore() {
				if (this.activeSector === undefined) {
					return this.projects.length
						? this.total > this.projects.length + this.perPage
						: true
				} else {
					return this.total > this.projects.length
				}
			},

			hasProjects() {
				return this.activeSector === undefined ? true : this.projects.length
			}
		},
		methods: {
			loadProjects(sector) {
				this.activeSector = sector
				this.projects = []
				this.page = 1

				if (!sector) {
					this.hasNext = true
				}

				if (!this.loading) {
					this.getProjects()
				}
			},

			getProjects() {
				this.loading = true
				this.hasNext = false

				let args = {
					posts_per_page: this.perPage,
					offset: this.projects.length,
					wpbb_job_sector: this.activeSector,
					offer: offer
				}

				this.get('sophia/v1/projects', args)
					.then((response) => {
						const data = response.data
						// console.log(data);
						this.loading = false
						this.total = data.total
						this.projects = [...this.projects, ...data.projects]
					})
					.catch((error) => {})
			},

			getSectors() {
				this.get('wp/v2/wpbb_job_industry', { per_page: 100 })
					.then((response) => {
						this.sectors = response.data
						// this.send = true;
					})
					.catch((error) => {
						// console.log(error)
					})
			},

			getSectorColor(id) {
				return this.sectors.filter((el) => el.id === id)[0].acf.sector_color
			},

			getSector(id) {
				return this.sectors.filter((el) => el.id === id)[0].name
			},

			isActiveSector(id) {
				return this.activeSector === id
			}
		}
	})
}
